import { ReactNode } from 'react';
import styles from './RootContainer.module.scss';

interface Props {
  children: ReactNode;
}
export function RootContainer({ children }: Props) {
  return <div className={styles.Container}>{children}</div>;
}
